
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import { State, Toggle } from 'react-powerplug'
import FormInput from './form-input'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "forminput"
    }}>{`FormInput`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong>{` Forms`}</p>
    <hr />
    <h2 {...{
      "id": "input"
    }}>{`Input`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`Form input for a single line text or numbers`}</p>
    <p><strong parentName="p">{`Default`}</strong></p>
    <Playground __position={1} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormInput\n      {...state}\n      id=\"input\"\n      onChange={e => setState({ value: e.target.value })}\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormInput
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormInput {...state} id='input' onChange={e => setState({
          value: e.target.value
        })} mdxType="FormInput" />}
  </State>
    </Playground>
    <p><strong parentName="p">{`Placeholder`}</strong></p>
    <Playground __position={2} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormInput\n      {...state}\n      id=\"input-placeholer\"\n      placeholder=\"Text placeholder\"\n      onChange={e => setState({ value: e.target.value })}\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormInput
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormInput {...state} id='input-placeholer' placeholder="Text placeholder" onChange={e => setState({
          value: e.target.value
        })} mdxType="FormInput" />}
  </State>
    </Playground>
    <p><strong parentName="p">{`Validation`}</strong></p>
    <Playground __position={3} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormInput\n      {...state}\n      id=\"input-validation\"\n      error=\"Notice\"\n      onChange={e => setState({ value: e.target.value })}\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormInput
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormInput {...state} id='input-validation' error="Notice" onChange={e => setState({
          value: e.target.value
        })} mdxType="FormInput" />}
  </State>
    </Playground>
    <p><strong parentName="p">{`Disabled`}</strong></p>
    <Playground __position={4} __code={'<FormInput\n  disabled\n  id=\"input-disabled\"\n  value=\"Text value\"\n  onChange={e => setState({ value: e.target.value })}\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormInput
    }} mdxType="Playground">
  <FormInput disabled id='input-disabled' value="Text value" onChange={e => setState({
        value: e.target.value
      })} mdxType="FormInput" />
    </Playground>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={FormInput} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;